import {combineReducers} from 'redux';
import User from './User';
export default combineReducers({
  User,
});
